
"use strict"; // jshint ignore:line

import { Vector3 } from '../../../src/js/three.module.js';
import { ObjectClickHandler }  from '../../utils/object-click-handler.js';
import { Oeuvre } from '../classes/oeuvre.js';
import { CommentsHandler } from '../services/CommentsService.js';

export default function ObjectClickHandlerService( $rootScope,  $compile,  $sce,  $injector,  gettextCatalog,  contextMenuService,  userActionHistoryService,  spherical360SetupService ) {

	var objectClickHandlerService = $rootScope.objectClickHandlerService = window.objectClickHandlerService = this;
	var self = this;

	/*************/

	contextMenuService.init( "objectClickHandler.object-settings", "templates/context-modals/objectClickHandler.object-settings.html", {
	});

	/**
	 *  @deprecated, siirretty componentiin src/js/components/context-modals/context-modal-body-object-click-handler-object-settings.component.js
	 * contextMenuService.buildTemplateScope( "templates/context-modals/objectClickHandler.object-settings.html", (function() {
		return {
			objectClickHandlerService: objectClickHandlerService,
			genNewEmptyAct: function( handler ) {
				var act = { conditions: [ '' ], fn: '', arguments: [] };

				if (handler.object instanceof Oeuvre) {
					act.fn = "openOeuvreInfoModal";
					onActFnChange( act.fn, act, handler );
				}

				return act;
			},
			addAct: function( act, handler ) {
				handler.pushAct( act );
			},
			onActFnChange: onActFnChange,
			genActHtmlString: (function(cache) {
				return function( act ) {
					var cache_key = JSON.stringify( act ), now = Date.now();

					if (cache[cache_key] && cache[cache_key].expires < now) {
						delete cache[cache_key];
					}

					if (!cache[cache_key]) {
						var str = "";
						
						var str_function = "", str_arguments = "", arr_arguments = [];
					
						if (act.conditions && Object.keys( act.conditions ).length > 0) {
							var parts = [];
							str = "Jos";

							for (var cond in act.conditions) {
								var value = act.conditions[ cond ];

								switch (cond) {
									default:
										var i18n_key = "label:object_click_condition-" + cond;
										if (gettextCatalog.getStringIfExists( i18n_key )) {
											parts.push( gettextCatalog.getString( i18n_key, { value: value }))
										} else {
											parts.push( cond );
										}
								}
							}

							for (var i = 0; i < parts.length; i++) {
								str += "<code>"+parts[i]+"</code>";
								if (i < parts.length - 2) {
									str += ",";
								} else if (i < parts.length - 1) {
									str += " ja";
								}
								str += " ";
							}

							str += "niin ";
						}

						/*******

						try {
							str_function = gettextCatalog.getStringIfExists( "label:object_click_fn-" + act.fn );
						} catch (error) {
							console.error( error );
						}

						try {
							switch (act.fn) {
								case "attachPlayerToSpherical360Setup":

									var setup = act.arguments[0] && spherical360SetupService.setups[ act.arguments[0] ];
									if (setup) {
										arr_arguments = [ setup.name || setup.uuid ];
									}
									break;
								case "openOeuvreInfoModal":
									var oeuvre = act.arguments[0] && $rootScope.oeuvres[ act.arguments[0] ];
									if (oeuvre) {
										arr_arguments = [ oeuvre.title || oeuvre.uid ];
									}
									break;
							}
						} catch (error) {
							console.error( error );
						}
			
						/**
						 * Fallbackit
						 *
					
						if (!str_function) {
							str_function = act.fn;
						}

						if (act.arguments[0] && arr_arguments.length != act.arguments.length) {
							arr_arguments = act.arguments;
						}
					
						/**
						 * Viimeistely
						 *
							
						str_function = "<code>" + str_function + "</code>";

						str_arguments = arr_arguments.map(function(argv) {
							return "<code>'"+argv+"'</code>";
						}).join( ", " );

						if (str_arguments) {
							str_arguments = " " + str_arguments + " ";
						}

						/************

						str = str + str_function + "(" + str_arguments + ")";

						cache[cache_key] = {
							html: $sce.trustAsHtml( str ),
							expires: now + 10000
						};
					}

					return cache[cache_key].html;
				};
			})({})
		};

		function onActFnChange( fn, act, handler ) {
			act.arguments = [];
			try {
				switch (fn) {
					case "setPlayerPositionRotation":
						act.arguments = [ player.pos.toArray(), player.av, player.ah ];
						break;
					case "openOeuvreInfoModal":
						act.arguments = [ handler.object.uid ];
						break;
				}
			} catch (error) {
				console.error( error );
			}
		}

	})()); */
	
	/*************/

	angular.extend( ObjectClickHandler.actFns, {

		"openOeuvreInfoModal": (function( oeuvreInfoModalOpener ) {

			var opts = {
				templateUrl        : "templates/oeuvre-info-modal.html",
				controllerBasepath : "js/controllers/",
				size               : "lg"
			};

			var modal;

			return function openOeuvreInfoModal( event, oeuvre_uid ) {

				if (!oeuvreInfoModalOpener) {

					try {
						if ($injector.get( "$templateCache" ).get( "oeuvre-info-modal.html" )) {
							opts.templateUrl = "oeuvre-info-modal.html";
						}
					} catch (error) {}

					oeuvreInfoModalOpener = $injector.get( "modalOpenerGenerator" ).generate( "oeuvre-info-modal", opts, [ "oeuvre" ]);
				}

				return $injector.get( "$userAssets" ).getClientOeuvreSingles([ oeuvre_uid ]).then(function( oeuvres ) {

					return modal = oeuvreInfoModalOpener( oeuvres[0], { });

				});
			}
		})(),

		"attachPlayerToSpherical360Setup": function( event, target_uuid ) {

			if (target_uuid) {

				spherical360SetupService.attachPlayer( target_uuid );
			}
		},

		"setPlayerPositionRotation": function( event = {}, position = null, av = null, ah = null ) {

			try {
				if (position == null || (!position[0] && !position[1] && !position[2])) {
					// Siirrytään kohti klikattua pistettä s.e. ollaan siitä 0.25 metrin etäisyydellä
					var delta = event.$intersect.point.clone().sub( player.pos ).normalize();
					position = event.$intersect.point.addScaledVector( delta, -0.25 ).toArray( );
				}
			} catch (error) {
				console.error( error );
			}

			if (Array.isArray( position )) {
				player.walkToPosition( new Vector3().fromArray( position ));
				// player.setHeadPos( new Vector3().fromArray( position ));
			}

			if (angular.isNumber( av )) {
				player.av = av;
			}

			if (angular.isNumber( ah )) {
				player.ah = ah;
			}
		},

		"showTextContextMenu": function( event, source = "", text = "", options = { size: "" } ) {

			var html = "", obj = event.$clickHandler.object;

			switch (source) {
				case "obj_comment_content":
					if (obj.comments && obj.comments instanceof CommentsHandler) {
						html = [];
						for (var i = 0; i < obj.comments.length; i++) {
							if (obj.comments[i].text) html.push( obj.comments[i].text );
						}
					}
					break;

				default:
					html = [ text ];
			}

			if (!html || !html.length) return;
			
			if (Array.isArray( html )) html = html.map(function( p, i ) { return '<p class="mb-0 ' + (i==0?'':'mt-1') + '">' + p + "</p>" }).join( "\n" );

			html = $sce.trustAsHtml( html );

			setTimeout(function() {
				contextMenuService.run( "html", event.clientX, event.clientY, { html }, { size: options.size });
			});
		}
	});
}

ObjectClickHandlerService.$inject = [ "$rootScope","$compile","$sce","$injector","gettextCatalog","contextMenuService","userActionHistoryService","spherical360SetupService" ];
